import { render } from "./onbording.vue?vue&type=template&id=3ed4a159&scoped=true"
import script from "./onbording.vue?vue&type=script&lang=js"
export * from "./onbording.vue?vue&type=script&lang=js"

import "./onbording.vue?vue&type=style&index=0&id=3ed4a159&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed4a159"]])

export default __exports__